/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CorporateGroupInputModel } from '../../models/corporate-group-input-model';
import { CorporateGroupModel } from '../../models/corporate-group-model';

export interface PutApiCorporategroupV1Id$Json$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: CorporateGroupInputModel
}

export function putApiCorporategroupV1Id$Json(http: HttpClient, rootUrl: string, params: PutApiCorporategroupV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateGroupModel>> {
  const rb = new RequestBuilder(rootUrl, putApiCorporategroupV1Id$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CorporateGroupModel>;
    })
  );
}

putApiCorporategroupV1Id$Json.PATH = '/private/v1/corporate-groups/{id}';
